const PDF_SERVICE_HOST_FALLBACKS: Record<string, string> = {
  'strana-dev.itstrana.site': 'staging.strana.itstrana.site',
};

export function getPdfServiceHost (mainSiteHost: string | undefined): string {
  const host = (mainSiteHost || 'strana.com')
    .replace(/^https?:\/\//, '')
    .replace(/\/+$/, '');
  return PDF_SERVICE_HOST_FALLBACKS[host] ?? host;
}
